/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./download-model-button.vue?vue&type=template&id=50266586&scoped=true&"
import script from "./download-model-button.vue?vue&type=script&lang=ts&"
export * from "./download-model-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50266586",
  null
  
)

export default component.exports